import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/account_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {}
export const formColumnsConfig = {
  'self': {
    'email': { required: true, disabledUpdate: false },
    'name': { required: true, disabledUpdate: false },
    'phone': { required: true, disabledUpdate: false },
    'number': { required: true, disabledUpdate: false },
    'user_id': { required: false, disabledUpdate: false },
    'kind': { required: false, disabledUpdate: false },
    'agent_target_id': { required: false, disabledUpdate: false },
    'certificate_end_date': { required: false, disabledUpdate: false },
    'risk_assessment_level': { required: false, disabledUpdate: false },
    'address': { required: false, disabledUpdate: false },
    'city': { required: false, disabledUpdate: false },
    'referrer': { required: false, disabledUpdate: false },
    'is_staff': { required: false, disabledUpdate: false },
    'personas': { required: false, disabledUpdate: false },
    'audio_or_video_recording_file': { required: false, disabledUpdate: false },
    'bank_card_scan_file': { required: false, disabledUpdate: false },
    'fund_contract': { required: false, disabledUpdate: false },
    'number_scan_file': { required: false, disabledUpdate: false },
    'proof_of_assets': { required: false, disabledUpdate: false },
    'qualified_investor_commitment_letter': { required: false, disabledUpdate: false },
    'risk_assessment_file': { required: false, disabledUpdate: false },
    'risk_disclosure': { required: false, disabledUpdate: false },
    'supplementary_agreement_to_fund_contract': { required: false, disabledUpdate: false },
    'other_files': { required: false, disabledUpdate: false },
    'type': { required: true, disabledUpdate: true },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Account', columns), filterColumnsExtend)
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Account', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
